function useEnvironment() {
  // eslint-disable-next-line
  const mode = process.env.NODE_ENV;
    //one of development (npm run start), production (npm run build), test (npm run test)
  const environment = process.env.REACT_APP_ENV;
    //one of mock (npm run start:mock) dev (npm run start), sit (npm run start:sit or npm run build:sit), prod (npm run start:prod or npm run build)
  return { environment, mode };
};

export default useEnvironment;